function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.4928 0.472768C23.3889 0.383231 23.241 0.362458 23.1156 0.419567L0.466651 10.7562C0.344717 10.8119 0.266196 10.9314 0.26473 11.0634C0.263265 11.1955 0.339203 11.3166 0.459951 11.3748L6.86957 14.4646C6.98711 14.5213 7.12726 14.5085 7.23223 14.4314L13.4641 9.85625L8.57183 14.7993C8.50204 14.8698 8.46644 14.9664 8.47412 15.0645L8.96123 21.2957C8.97205 21.4337 9.06627 21.5518 9.20021 21.595C9.23602 21.6066 9.2728 21.6122 9.30916 21.6122C9.4089 21.6122 9.50592 21.5702 9.57341 21.4934L12.9754 17.6211L17.181 19.5949C17.2723 19.6377 17.378 19.6395 17.4707 19.5999C17.5635 19.5602 17.6341 19.483 17.6644 19.3882L23.5956 0.833178C23.637 0.703604 23.5966 0.562305 23.4928 0.472768Z",
  fill: "white"
});

var SvgPlane = function SvgPlane(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlane, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plane.d73b324f.svg";
export { ForwardRef as ReactComponent };